export const SOCIAL = {
    fb: `https://www.facebook.com/vivekamethi`,
    ig: `https://instagram.com/viveksinghup`,
    tw: `https://twitter.com/viveksinghup`,
    in: `https://in.linkedin.com/in/viveksinghup`,
    gt: `https://github.com/viveksinghup`,
};

export const MOBILE = `+91 85068 17383`;
